import { render, staticRenderFns } from "./deudor.vue?vue&type=template&id=773fbdc2&scoped=true"
import script from "./deudor.vue?vue&type=script&lang=js"
export * from "./deudor.vue?vue&type=script&lang=js"
import style0 from "./deudor.vue?vue&type=style&index=0&id=773fbdc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773fbdc2",
  null
  
)

export default component.exports